const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/schedulingSlot.ts';
import { IActionHandlersMap, KisApiAction, makeReducer, ReducerState } from '@cistec/common_web/defs/actionTypes';
import {
    addRequestActionHandlers,
    getData,
    getDataFromPayloadWithListObject,
    isLoading,
    removeStructure,
} from '@cistec/common_web/utils/redux4Requests';
import {
    ACTION_TYPE_RESET_APPOINTMENT_BOOKING_SLOTS,
    REQUEST_ACTION_TYPES_LOAD_SCHEDULING_SLOTS,
    REQUEST_ACTION_TYPES_LOAD_SCHEDULING_SLOTS_FOR_TERMIN,
} from 'App/actions/schedulingSlot';
import { PatAppStoreState } from './setup/rootReducer';
import { createSelector } from 'reselect';

const KEY_SLOTS = 'slots';
const KEY_SLOTS_PER_TERMIN = 'slotsPerTermin';

const handleResetAppointmentBookingSlots = (state: ReducerState) => {
    return removeStructure(state, [KEY_SLOTS]);
};

const handlers: IActionHandlersMap = {
    [ACTION_TYPE_RESET_APPOINTMENT_BOOKING_SLOTS]: handleResetAppointmentBookingSlots,
};

addRequestActionHandlers(
    handlers,
    REQUEST_ACTION_TYPES_LOAD_SCHEDULING_SLOTS,
    [KEY_SLOTS],
    getDataFromPayloadWithListObject
);

const getSchedulingSlotsForTerminKeys = (action: KisApiAction) => {
    return [KEY_SLOTS_PER_TERMIN, action.meta.terminNr];
};

addRequestActionHandlers(
    handlers,
    REQUEST_ACTION_TYPES_LOAD_SCHEDULING_SLOTS_FOR_TERMIN,
    getSchedulingSlotsForTerminKeys,
    getDataFromPayloadWithListObject
);

export const schedulingSlotsReducer = makeReducer(handlers);

// SELECTORS

const selectReducerState = (state: PatAppStoreState) => state.schedulingSlots;

export const selectAvailableSchedulingSlotsForSelectedPlan = createSelector(
    [selectReducerState],
    (state: ReducerState) => getData(state, [KEY_SLOTS])
);

export const selectIsAvailableSchedulingSlotsForSelectedPlanLoading = createSelector(
    [selectReducerState],
    (state: ReducerState) => isLoading(state, [KEY_SLOTS])
);

export const makeSelectIsLoadingAvailableSlotsForTermin = (terminNumber: string) =>
    createSelector([selectReducerState], (state: ReducerState) =>
        isLoading(state, [KEY_SLOTS_PER_TERMIN, terminNumber])
    );

export const makeSelectAvailableSlotsForTermin = (terminNumber: string) => (state: PatAppStoreState) =>
    getData(state.schedulingSlots, [KEY_SLOTS_PER_TERMIN, terminNumber]);
